import * as ACTION_TYPES from './Types';

const initialState = {
  ratesDetails: {},
  message: '',
  error: null,
}

export const ratesReducer = (state = initialState, action) => {
  switch (action.type) {

    case ACTION_TYPES.UPLOADRATES_SUCCESS:
      return {
        ...state,
        ratesDetails: action.payload.data,
        message: action.payload.message,
      }

    case ACTION_TYPES.UPLOADRATES_ERROR:
      return {
        ...state,
        message: action.payload.message,
      }

    default:
      return state;
  }
}
